/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_OfflineInputs */

const en_share_offline = /** @type {(inputs: Share_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing needs a connection.`)
};

const de_share_offline = /** @type {(inputs: Share_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links teilen geht nur mit Verbindung.`)
};

/**
* | output |
* | --- |
* | "Sharing needs a connection." |
*
* @param {Share_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_offline = /** @type {((inputs?: Share_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_offline(inputs)
	return en_share_offline(inputs)
});